import { parse, format, isValid } from 'date-fns'

/**
 * Converte data de dd/MM/yyyy para ISO datetime format (yyyy-MM-ddTHH:mm:ss.SSSZ)
 */
export const convertDateToIso = (dateString: string): string => {
  if (!dateString) return ''

  const date = parse(dateString, 'dd/MM/yyyy', new Date())
  
  if (!isValid(date)) return ''

  // Retorna no formato ISO datetime completo
  // Exemplo: 2026-02-08T17:23:25.582Z
  const isoString = date.toISOString()
  return isoString
}

/**
 * Converte data de dd/MM/yyyy para ISO date format (yyyy-MM-dd)
 */
export const convertDateToIsoDate = (dateString: string): string => {
  if (!dateString) return ''

  const date = parse(dateString, 'dd/MM/yyyy', new Date())
  
  if (!isValid(date)) return ''

  return format(date, 'yyyy-MM-dd')
}

/**
 * Converte string ISO (yyyy-MM-dd) em Date em meia-noite no fuso local.
 * Evita que new Date("2026-02-01") seja interpretado como UTC e vire o dia anterior no Brasil.
 */
export const parseIsoDateAsLocal = (isoDateStr: string): Date => {
  if (!isoDateStr || !isoDateStr.match(/^\d{4}-\d{2}-\d{2}/)) {
    return new Date(NaN)
  }
  const [y, m, d] = isoDateStr.substring(0, 10).split('-').map(Number)
  return new Date(y, m - 1, d)
}

/**
 * Converte string ISO (yyyy-MM-dd) em Date no fim do dia (23:59:59.999) no fuso local.
 * Usado como maxDate para que o último dia do período fique inteiro selecionável.
 */
export const parseIsoDateAsLocalEndOfDay = (isoDateStr: string): Date => {
  if (!isoDateStr || !isoDateStr.match(/^\d{4}-\d{2}-\d{2}/)) {
    return new Date(NaN)
  }
  const [y, m, d] = isoDateStr.substring(0, 10).split('-').map(Number)
  return new Date(y, m - 1, d, 23, 59, 59, 999)
}

/**
 * Converte data (yyyy-MM-dd, yyyy-MM-ddTHH:mm:ss ou dd/MM/yyyy) para dd/MM/yyyy (exibição em formulário)
 */
export const formatDateForDisplay = (dateString: string): string => {
  if (!dateString || !dateString.trim()) return ''

  const trimmed = dateString.trim()
  // API retorna yyyy-MM-dd ou ISO com hora (ex: 2026-02-22T00:00:00)
  if (trimmed.match(/^\d{4}-\d{2}-\d{2}/)) {
    const datePart = trimmed.substring(0, 10)
    const date = parse(datePart, 'yyyy-MM-dd', new Date())
    if (isValid(date)) return format(date, 'dd/MM/yyyy')
  }
  // Já está em dd/MM/yyyy
  if (trimmed.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    const date = parse(trimmed, 'dd/MM/yyyy', new Date())
    if (isValid(date)) return format(date, 'dd/MM/yyyy')
  }
  return ''
}
